import { useSyncExternalStore } from "react";

export interface IToast {
  id: number;
  title: string;
  description?: string;
  duration: number;
}

const TOAST_DURATION = 10000;

let toasts: IToast[] = [];
let nextId = 1;
const listeners = new Set<() => void>();

const emit = () => {
  listeners.forEach((listener) => listener());
};

export const dismissToast = (id: number) => {
  toasts = toasts.filter((toast) => toast.id !== id);
  emit();
};

// Callable outside React; rendered by <Toaster /> in RootLayout, which owns the auto dismiss
export const showToast = ({ title, description, duration = TOAST_DURATION }: Omit<IToast, "id" | "duration"> & {
  duration?: number;
}) => {
  const id = nextId++;
  toasts = [...toasts, { id, title, description, duration }];
  emit();

  return id;
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => toasts;

export const useToasts = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
